import type { Ref } from "vue";

type SetupStoreCompatibility<TStore, TActions> = {
  [K in keyof TStore]: Ref<TStore[K]>;
} & TActions;

export function assertSetupStoreCompatibility<TStore, TActions = object>() {
  return function <TActual extends SetupStoreCompatibility<TStore, TActions>>(
    store: TActual,
  ): TActual {
    return store;
  };
}
